<ngx-loading-bar color="#fff"></ngx-loading-bar>
<router-outlet></router-outlet>